<template>
  <div>
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :width="filterInfo.width"
        :list-type-info="filterInfo.listTypeInfo"
        :count="20"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        @handleFocus="focusClassify"
      ></e-search>
    </div>
    <div class="container">
      <eui-btn type="primary" @click="withdrawHandle(null)">批量撤回</eui-btn>
      <tableList
        ref="table"
        selection-show
        max-height="600"
        :table-data="tableData"
        :table-label="tableLabel"
        :row-key="rowKey"
        style="margin-top: 20px"
        :check-selectable="checkSelectable"
        :loading="tableLoading"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #handle="{ scope }">
          <eui-btn v-if="scope.row.confirmStatus === 3" type="text" @click="openCheckDialog(scope.row)">
            查看原因
          </eui-btn>
          <eui-btn v-if="scope.row.confirmStatus === 1" type="text" @click="withdrawHandle(scope.row)">撤回</eui-btn>
        </template>
      </tableList>
      <!-- <div class="margin-t20">
        <el-checkbox v-model="checkedAll">全部页下数据</el-checkbox>
      </div> -->
      <div class="page-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="listQuery.pageSize"
          :total="total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>

    <CheckReason :reason-visible.sync="reasonVisible" :refuse-reasons="refuseReasons"></CheckReason>

    <!-- 推荐类目 -->
    <ClassifyTree
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    />
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import tableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/agreement/index';
import CheckReason from './checkReason.vue';

import { suppliers, goodsAuditMap } from '../mixins';

export default {
  components: {
    eSearch,
    tableList,
    CheckReason,
  },
  mixins: [suppliers, goodsAuditMap],
  props: {
    agreementId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkedAll: false,
      rowKey: 'id',
      tableData: [],
      total: 0,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        confirmStatus: 1,
        skuCode: '',
        skuName: '',
        agreementName: '',
        categoryIdList: [],
        supplierCompanyId: '',
        updateBy: '',
        startTime: '',
        endTime: '',
        agreementId: this.agreementId,
      },
      cloneListQuery: {},
      auditVisible: false,
      selectData: [],

      reasonVisible: false,
      reasonRow: {},

      refuseReasons: '',
    };
  },
  mounted() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getQueryShareCategoryTree({ agreementId: this.agreementId }); // 需要协议id agreementId
    this.getList(this.listQuery);
  },
  methods: {
    refresh() {
      this.getList(this.listQuery);
      this.$emit('countRefresh');
    },

    async getList(params) {
      const result = await Api.queryAuditSkuPage(params);
      try {
        this.tableLoading = true;
        if (result.code === '200') {
          const { data } = result;
          this.tableData = [...data.records];
          this.total = data.total;
          /* this.$nextTick(() => {
            this.$refs.table.handleClearSelection();
          }); */
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.tableLoading = false;
      }
    },
    // auditByCondition
    async withdrawHandleAll() {
      this.$confirm('确定要撤回调价吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const result = Api.auditByCondition(this.listQuery);
          if (result.code === '200') {
            this.$message({
              type: 'success',
              message: '撤回成功!',
            });
            this.getList(this.listQuery);
            this.$emit('countRefresh');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤回',
          });
        });
    },
    async withdrawHandle(row) {
      const params = {
        auditStatus: 0,
        agreementPriceEditList: [],
      };
      if (this.checkedAll) {
        // 全部撤回
        this.withdrawHandleAll();
        return;
      }
      if (row) {
        // 单个撤回
        const { priceId, skuId, supplierCompanyId, confirmStatus } = row;
        params.agreementPriceEditList = [{ priceId, skuId, supplierCompanyId, confirmStatus }];
      } else {
        if (this.selectData.length === 0) {
          this.$message.warning('请选择需要审核的数据');
          return;
        }
        const agreementPriceEditList = this.selectData.map((item) => ({
          priceId: item.priceId,
          skuId: item.skuId,
          supplierCompanyId: item.supplierCompanyId,
          confirmStatus: item.confirmStatus,
        }));
        params.agreementPriceEditList = agreementPriceEditList;
      }
      this.$confirm('确定要撤回调价吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const result = await Api.batchCallBack(params);
          if (result.code === '200') {
            this.$message({
              type: 'success',
              message: '撤回成功!',
            });
            this.getList(this.listQuery);
            this.$emit('countRefresh');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'info',
            message: '已取消撤回',
          });
        });
      //
    },

    // --------
    // 可以勾选的
    checkSelectable(row) {
      if (this.checkedAll) {
        return false;
      }
      if (row.confirmStatus === 1) {
        return true;
      }

      return false;
    },
    handleSelectionChange(val) {
      this.selectData = [...val];
    },

    handleFilter(val) {
      console.log(val, '搜索');
      if (val.auditTime) {
        const [startTime, endTime] = val.auditTime;
        val.startTime = startTime;
        val.endTime = endTime;
      } else {
        delete val.startTime;
        delete val.endTime;
      }
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },

    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
      this.$emit('countRefresh');
    },

    handlePageChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    openCheckDialog(row) {
      this.refuseReasons = row.refuseReasons;
      this.reasonVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.margin-t20 {
  margin-top: 20px;
}
.page-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
